import component from './valuebar.component'
import './valuebar.scss'

let module = angular.module('valuebar', [])
	.component('valuebar', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/valuebar/valuebar.js